module.exports = __webpack_public_path__ + "static/media/help2.d6200198.png";